<template>
    <!--<div class="x-handle" @mousedown="mouseDown"></div>-->
    <div id="louter-selected" class="x-handle" :style="{width: '2px', height: leftHeight, background: background, paddingRight: outerSeletedPaddingTop, zIndex: '10'}" @mousedown="mouseDown">
        <div :style="{ height: leftHeight, width: height, background:background, cursor: 'col-resize'}"></div>
    </div>
</template>

<script>
    export default {
        name: "XHandle",
        data() {
            return {
                lastX: "",
                height: '2px',
                background: '#E1E4E8',
                flag: true,
                outerSeletedPaddingTop: '0px',
            };
        },
        props:{
            leftHeight: String,
        },

        created() {
            document.addEventListener("mouseup", this.mouseUp);
        },
        mounted() {
            document.getElementById("louter-selected").addEventListener("mouseenter", this.mouseEnter);
            document.getElementById("louter-selected").addEventListener("mouseleave", this.mouseLeave);
        },

        destroyed() {
            document.removeEventListener("mouseup", this.mouseUp);
        },

        methods: {
            mouseEnter() {
                this.background = '#2188FF';
            },
            mouseLeave() {
                if(this.flag){
                    this.background = '#2188FF';
                }else{
                    this.background=  '#E1E4E8';
                }
            },
            mouseDown(event) {
                document.addEventListener("mousemove", this.mouseMove);
                this.lastX = event.screenX;
                this.flag = true;
            },
            mouseMove(event) {
                this.$emit("leftWidthChange", this.lastX - event.screenX);
                this.lastX = event.screenX;
                this.flag = true;
                // console.log(">>>>", this.lastX, "...", event.screenX);
            },
            mouseUp() {
                this.lastX = "";
                document.removeEventListener("mousemove", this.mouseMove);
                this.flag = false;
                this.background=  '#E1E4E8';
            }
        }
    };
</script>
<style lang="less" scoped>
    /*.x-handle {*/
        /*width: 2px;*/
        /*cursor: w-resize;*/
        /*z-index: 10;*/
        /*background: red;*/
    /*}*/
    #midline {
        cursor: col-resize;
    }
    .x-handle {
        /*background: red;*/
        /*width: 10px;*/
        cursor: col-resize;
        /*z-index: 10;*/
        /*background: #ccc;*/
    }
</style>
